import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthGuard from './auth-guard';
//import SubscribeGuard from './subscribe-guard';
//import Login from '../views/Authenticate/Login.vue';


Vue.use(VueRouter);

//const routes = [

// {
//   path: "/about",
//   name: "About",
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   component: () =>
//     import(/* webpackChunkName: "about" */ "../views/About.vue")
// }
// beforeEnter(to, from, next) {
//   const token = localStorage.getItem('token');
//   const expirationDate = localStorage.getItem('expirationDate')
//   const now = new Date();
//   if (token == null || now >= expirationDate) {
//     next('/login')
//   } else {
//     next()
//   }
// }
//];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
      // meta: { authRequired: true },
      beforeEnter: AuthGuard,
    },
    {
      path: '/login',
      component: () => import('../views/Authenticate/Login.vue'),
      // beforeEnter: ifNotAuthenticated,
    },

    
    {
      path: '/register',
      component: () => import('../views/Authenticate/Signup.vue'),
      
    },
    // {
    //   path: '/subscribe',
    //   component: () => import('../views/Authenticate/Subscribe.vue'),
    //   beforeEnter: SubscribeGuard,
      
    // },
    {
      path: '/forgotPassword',
      component: () => import('../views/Authenticate/ForgotPassword.vue'),
    },

    {
      path: '*',
      redirect: '/login',
    },
  ],
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.authRequired)) {
//     if (store.getters.user) {
//       next()
//     } else {
//       next('/login');
//     }
//   } else {
//     next();
//   }
// });

export default router;
